import axios from "axios"

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:3001",
})

export const api_v2 = axios.create({
  baseURL: import.meta.env.VITE_API_URL_V2 || "http://localhost:3001",
})

// Função para deslogar e limpar os dados do usuário
const handleLogout = () => {
  localStorage.removeItem("token") // Ou o nome da chave que você usa
  localStorage.removeItem("user") // Ou o nome da chave que você usa
  // O window.location.href força um reload e limpa estados do React/Context
  if (
    (localStorage.getItem("token") === null || localStorage.getItem("user") === null) &&
    window.location.href !== "/login"
  ) {
    window.location.href = "/login"
  }
}

// Interceptor para tratar erros globalmente
const setupInterceptors = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response, // Se a resposta for sucesso, apenas retorna
    (error) => {
      if (
        error.response &&
        (error.response.status === 403 ||
          error.response.status === 401 ||
          error.response.status === 500)
      ) {
        handleLogout()
      }

      return Promise.reject(error)
    }
  )
}

// Aplicando aos dois clientes
setupInterceptors(api)
setupInterceptors(api_v2)

export default api
